import { MagicVariables } from "@/types";

export class VideoFavorite implements MagicVariables {
    $root: HTMLElement;
    isFavorite: boolean;
    showTooltip = false;
    timeoutId: ReturnType<typeof setTimeout> | null = null;
    timeoutDuration = 3000;

    constructor(initialFavoriteState: boolean = false) {
        this.isFavorite = initialFavoriteState;
    }

    handleAfterRequest(event: CustomEvent): void {
        if (event.detail.xhr.status === 200) {
            this.isFavorite = !this.isFavorite;
            this.showTooltip = true;
            this.$root.setAttribute('aria-pressed', `${this.isFavorite}`);

            if (this.timeoutId) {
                clearTimeout(this.timeoutId);
            }

            this.timeoutId = setTimeout(() => {
                this.showTooltip = false;
            }, this.timeoutDuration);
        }
    }

    getHeartIconClasses(): Record<string, boolean> {
        return {
            'text-icon-accent-primary': this.isFavorite,
            'text-icon-base-tertiary group-hover:text-link-secondary': !this.isFavorite
        };
    }

    destroy(): void {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
}
